export interface IPlaceCategoryProduct {
  id: string
  /**
   * ProductGroup.section 값과 매칭하기 위한 코드
   * (android ProductGroupSection enum 기준)
   */
  section: string
  name: string
  /** 상품 설명. TODO: 기획 확정 후 문구 추가 */
  description: string
  imageUrl: string
}

const MYCLE_PRODUCT_IMAGE_BASE = 'https://mycle.co.kr/resources/images/product'

/**
 * 정비소 상세 페이지 상품별 가격 섹션에서 사용하는 카테고리 순서.
 * GET /productGroups?placeId=X&lowestPrice=true 응답의 section 필드와 매칭되는
 * 항목만 노출된다.
 */
export const PLACE_CATEGORY_PRODUCTS: IPlaceCategoryProduct[] = [
  {
    id: 'engine-oil',
    section: 'oil_set',
    name: '엔진오일',
    description: '엔진오일 + 에어크리너 + 오일필터 + 공임비 포함',
    imageUrl: `${MYCLE_PRODUCT_IMAGE_BASE}/engineoil_x3.png`,
  },
  {
    id: 'tire',
    section: 'tire',
    name: '타이어',
    description: '마이클 인증 타이어 배송비 + 공임비 포함',
    // 타이어만 별도 리소스 경로 (1:1 비율 보정용)
    imageUrl:
      'https://mycle.co.kr/resources/images/product/tire_seo_260427.png',
  },
  {
    id: 'car-wash',
    section: 'car_wash',
    name: '세차',
    description: '실내 + 실외 + 프리미엄 손세차',
    imageUrl: `${MYCLE_PRODUCT_IMAGE_BASE}/eva_cleaning.png`,
  },
  {
    id: 'battery',
    section: 'battery',
    name: '배터리',
    description: '배터리 + 공임비 포함',
    imageUrl: `${MYCLE_PRODUCT_IMAGE_BASE}/battery_standard.png`,
  },
  {
    id: 'wiper',
    section: 'wiper_blade',
    name: '와이퍼',
    description: '전면 와이퍼 블레이드 + 공임비 포함',
    imageUrl: `${MYCLE_PRODUCT_IMAGE_BASE}/wiper_blade.png`,
  },
  {
    id: 'cabin-filter',
    section: 'cabin_filter',
    name: '에어컨 필터',
    description: '에어컨 필터 + 공임비 포함',
    imageUrl: `${MYCLE_PRODUCT_IMAGE_BASE}/cabin_filter_carbon_221114.png`,
  },
  {
    id: 'brake-pad',
    section: 'brake_pad',
    name: '브레이크 패드',
    description: '브레이크 패드 + 공임비 포함',
    imageUrl: `${MYCLE_PRODUCT_IMAGE_BASE}/brake_pad_front_back.png`,
  },
  {
    id: 'tire-rotation',
    section: 'tire_rotation',
    name: '타이어 위치 교환',
    description: '타이어 위치 교환 + 휠 밸런스 조정 서비스 포함',
    imageUrl: `${MYCLE_PRODUCT_IMAGE_BASE}/tire_rotation_220913.png`,
  },
  {
    id: 'ac-gas',
    section: 'air_conditioner',
    name: '에어컨 가스',
    description: '에어컨 가스(냉매) + 공임비 포함',
    imageUrl: `${MYCLE_PRODUCT_IMAGE_BASE}/air_conditioner_single.png`,
  },
  {
    id: 'wheel-alignment',
    section: 'wheel_alignment',
    name: '휠얼라인먼트',
    description: '휠얼라인먼트 점검 + 공임비 포함',
    imageUrl: `${MYCLE_PRODUCT_IMAGE_BASE}/tire_alignment_01.png`,
  },
  {
    id: 'brake-oil',
    section: 'oil_brake',
    name: '브레이크 오일',
    description: '브레이크 오일 + 공임비 포함',
    imageUrl: `${MYCLE_PRODUCT_IMAGE_BASE}/brake_oil.png`,
  },
  {
    id: 'spark-plug',
    section: 'spark_plug',
    name: '점화 플러그',
    description: '점화 장치 부품 + 공임비 포함',
    imageUrl: `${MYCLE_PRODUCT_IMAGE_BASE}/spark_plug.png`,
  },
  {
    id: 'antifreeze',
    section: 'antifreezer',
    name: '부동액',
    description: '부동액 + 공임비 포함',
    imageUrl: `${MYCLE_PRODUCT_IMAGE_BASE}/antifreezer.png`,
  },
  {
    id: 'mission-oil',
    section: 'oil_mission',
    name: '미션오일',
    description: '미션오일 + 공임비 포함',
    imageUrl: `${MYCLE_PRODUCT_IMAGE_BASE}/oil_mission.png`,
  },
  {
    id: 'fuel-filter',
    section: 'fuel_cartridge',
    name: '연료필터',
    description: '연료필터 어셈블리/카트리지 + 공임비 포함',
    imageUrl: `${MYCLE_PRODUCT_IMAGE_BASE}/fuel_filter.png`,
  },
  {
    id: 'inspection',
    section: 'safe_inspect',
    name: '내 차 점검',
    description: '26가지 항목 점검',
    imageUrl: `${MYCLE_PRODUCT_IMAGE_BASE}/inspection_220502.png`,
  },
  {
    id: 'diagnosis',
    section: 'diagnosis',
    name: '고장 진단',
    description: '입력한 증상에 기반한 원인 진단',
    imageUrl: 'https://mycle.co.kr/app-images/product-img_diagnosis.png',
  },
]

export const PLACE_PRODUCT_LIST_INITIAL_COUNT = 3
